import React, { useMemo } from "react";
import Dropdown from "components/dropdown";
import { FiAlignJustify } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import { HiChevronRight } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "store/authSlice";
import { FaCircleUser } from "react-icons/fa6";
import { useDarkMode } from "context/DarkModeContext";

const Navbar = (props) => {
  const { onOpenSidenav, brandText } = props;
  const { darkmode, toggleDarkmode } = useDarkMode();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/sign-in", { replace: true });
  };
  const parts = useMemo(() => {
    if (!brandText) return [];
    return brandText.replace(/^\//, "").split("/");
  }, [brandText]);

  const title = useMemo(() => {
    if (parts.length === 1) {
      return parts[0];
    } else if (parts.length >= 2) {
      // swap: last part first, then second-to-last
      return `${parts[parts.length - 1]} ${parts[parts.length - 2]}`;
    }
    return "";
  }, [parts]);

  return (
    <nav className="sticky top-4 z-40 flex flex-row  items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
      <div className="ml-[6px]">
        <div className="flex h-6 w-[200px] flex-row items-center pt-1  md:h-8">
          <Link
            className="text-sm font-normal text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            to={"/dashboard"}
          >
            Home
          </Link>

          {parts.map((part, idx) => {
            const fullPath = "/" + parts.slice(0, idx + 1).join("/");
            return (
              <div key={idx} className="flex flex-row items-center">
                <HiChevronRight className="mx-1 text-navy-700 dark:text-white" />
                <p
                  className={`text-sm font-bold font-normal capitalize text-navy-700 dark:text-white`}
                >
                  {part}
                </p>
              </div>
            );
          })}
        </div>

        <p className="shrink text-xl capitalize text-navy-700 dark:text-white md:text-[24px]">
          <span className="font-bold capitalize">{title}</span>
        </p>
      </div>

      <div className="relative mt-[3px] flex h-[61px] w-[355px] flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[160px] md:flex-grow-0 md:gap-1 xl:w-[120px] xl:gap-2">
        <span
          className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden"
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-5 w-5" />
        </span>

        <div className="cursor-pointer text-gray-600" onClick={toggleDarkmode}>
          {darkmode ? (
            <RiSunFill className="h-4 w-4 text-gray-600 dark:text-white" />
          ) : (
            <RiMoonFill className="h-4 w-4 text-gray-600 dark:text-white" />
          )}
        </div>
        {/* Profile & Dropdown */}
        <Dropdown
          button={
            <FaCircleUser className="h-8 w-8 text-gray-600 dark:text-white" />
          }
          children={
            <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div className="p-4">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    {userInfo?.firstname
                      ? `👋 Hey, ${userInfo.firstname}`
                      : "👋 Hey"}
                  </p>
                </div>
              </div>
              <div className="h-px w-full bg-gray-200 dark:bg-white/20 " />

              <div className="flex flex-col p-4">
                <Link
                  to="/profile"
                  className="text-sm text-gray-800 dark:text-white hover:dark:text-white"
                >
                  Profile Settings
                </Link>
                <a
                  href=" "
                  onClick={(e) => {
                    e.preventDefault();
                    handleLogout();
                  }}
                  className="mt-3 text-sm font-medium text-red-500 transition duration-150 ease-out hover:text-red-500 hover:ease-in"
                >
                  Log Out
                </a>
              </div>
            </div>
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        />
      </div>
    </nav>
  );
};

export default Navbar;
